import React from 'react';
import { useFormikContext } from 'formik';

import RadioButtonGroup from '../../../RadioButtonGroup';
import fieldName from '../../formFields';

import texts from './texts.json';
import {
  Container,
  StyledTitle,
  ToggleContainer,
  ToggleDescription,
} from './styles';

const ToggleOption = {
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
};

const TextBlastConsentToggleOptions = Object.entries(ToggleOption).map(([key, value]) => ({
  value,
  label: texts.toggleOptions[value],
  key,
}));

const TextBlastConsent = () => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <Container>
      <StyledTitle>{texts.title}</StyledTitle>
      <ToggleContainer>
        <ToggleDescription>{texts.toggleDescription}</ToggleDescription>
        <RadioButtonGroup
          options={TextBlastConsentToggleOptions}
          selectedOption={values[fieldName.TEXT_BLAST_CONSENT] ? ToggleOption.ENABLE : ToggleOption.DISABLE}
          onOptionChange={(value) => setFieldValue(fieldName.TEXT_BLAST_CONSENT, value === ToggleOption.ENABLE)}
          isRow
        />
      </ToggleContainer>
    </Container>
  );
};

export default TextBlastConsent;
